/**
 * Created by fajar on 06/28/2018.
 * Updated by cahyo
 *
 * UserService class for provide user rest
 * with singleton concept provided by decorator
 */

import { Singleton } from 'annotation';
import environment from 'environment';
import { uniqBy } from 'lodash';
import { Deserialize } from 'cerialize';

import ProxyService from './Proxy';

import EntityAware from '../entity/EntityAware';
import User from '../entity/User';
import Menu from "../entity/Menu";
import Parameter from "./Parameter";
import Response from "./Response";

@Singleton
export default class UserService extends ProxyService {

    public api: string = environment.USER_API;   // define api url to fetch data

    public serializer: EntityAware = User;       // define serializer after fetch data

    public login(entity: User): Promise<any> {
        const payload = { username: entity.username, password: entity.password };

        const parameter: Parameter = new Parameter(payload)
            .setMethod(Parameter.methods.POST)
            .setEnableNotif(false)
            .setUrl(environment.LOGIN_API);

        return super.request(parameter).then((response: Response) => {
            return response;
        });
    }

    public logout(): void {
        // Logic moved to AuthStore
    }

    public find(T: EntityAware): Promise<any> {
        return super.find(T).then((response: Response) => {
            return response.sortData();
        });
    }

    public save(T: User): Promise<any> {
        const parameter = new Parameter(T).setMethod(Parameter.methods.POST)
            .setUrl(`${this.api}/register`);

        return this.request(parameter);
    }

    public changePassword(param: any) {
        let url: string = this.api + '/change-password';
        const parameter = new Parameter(param).setMethod(Parameter.methods.POST).setUrl(url).setEnableNotif(false);
        return this.request(parameter);
    }

    public resetPassword(param: any) {
        let url: string = this.api + '/reset-password';
        const parameter = new Parameter(param).setMethod(Parameter.methods.POST).setUrl(url);
        return this.request(parameter);
    }

    public deleteUser(param: any) {
        let url: string = this.api + '/remove-user';
        const parameter = new Parameter(param).setMethod(Parameter.methods.POST).setUrl(url);
        return this.request(parameter);
    }

    public findMenus(id: string): Promise<any> {
        const sortCallback = (a: any, b: any) => {
            return (a['number'] || 0) - (b['number'] || 0);
        };

        const deserializeIt: Function = (params: any): Array<any> => {
            return params.filter((item: any) => {
                return !['beranda', 'dashboard'].some((word: string) =>
                    item.name && item.name.toLowerCase().includes(word));
            }).map((item: any) => {
                item = Deserialize(item, Menu);
                if (item.childs != null) {
                    item.childs = deserializeIt(item.childs, true).sort(sortCallback);
                }

                return item
            })
        };

        return super.find("/menus/" + id).then((response: Response) => {
            // due to the menu parent is always the role name menu
            // we append the dashboard menu hardcode
            if (response.getData() && Array.isArray(response.getData()) && response.getData().length) {
                const formatedData = uniqBy(response.getData(), 'id').sort(sortCallback);

                const data: Array<any> = deserializeIt(formatedData);

                const dashboard = new Menu();
                dashboard.name = 'Beranda'; // Hardcoded to avoid circular dependency with AppConfig
                dashboard.icon = 'far fa-tachometer-alt';
                dashboard.url = '/index';
                data.unshift(dashboard);

                return data;
            }

            return [];
        });
    }

    public changeRole(param: User): Promise<any> {
        const api: string = this.api + `/change-role`;
        const parameter = new Parameter(param).setMethod(Parameter.methods.POST).setUrl(api);
        parameter.showNotification = true;

        return this.request(parameter);
    }

}
